import Styles from './NodeJupyter.module.scss';
import ImportedStyles from '../NodeTerminal/NodeTerminal.module.scss';
import React, { useEffect, useState, useRef, useContext } from 'react';
import { useNavigate, useParams } from 'react-router-dom';


// Module imports.
import { Avatar, Typography, Backdrop, LinearProgress, Box, Fab } from '@mui/material';
import { ToastContainer, toast } from 'react-toastify';
import { pink } from '@mui/material/colors';
import SmartToyIcon from '@mui/icons-material/SmartToy';
import { Python3Parser } from 'dt-python-parser';
import _ from 'lodash';
import axios from 'axios';
import VisibilityIcon from '@mui/icons-material/Visibility';


// Components import.
import { JupyterTerminal } from 'components/global/NodeLayout/JupyterTerminal/JupyterTerminal';
import { NodeTimeline } from 'components/global/NodeLayout/NodeTimeline';
import { LightTooltip } from 'components/global/NodeLayout/NodeTopostman';
import { ConfirmationCard } from 'components/global/ConfirmationCard/ConfirmationCard';
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';
import { LoadingBackdrop } from 'components/global/LoadingBackdrop/LoadingBackdrop';


// assets
import { useAPI, AuthContext, Feedback, ViewContext, useCan } from 'components/lib';
import { decoder } from 'utils/helpers/decoder';
import InfoDrawer from 'components/global/NodeLayout/InfoDrawer';
import ViewInArIcon from '@mui/icons-material/ViewInAr';
import { Joyride } from 'components/walkthrough/walkthrough';
import { BackConfirmationCard } from 'components/global/BackConfirmationCard/BackConfirmationCard';
import { HelperChat } from 'components/global/HelperChat/HelperChat';
import LightbulbIcon from '@mui/icons-material/Lightbulb';
import { copyEnabledChecker } from 'utils/helpers/utility';
import RevealAnswerKey from 'components/RevealAnswerKey/RevealAnswerKey';
import { InstructionPane } from 'components/global/InstructionPane/InstructionPane';
import ContainerLoader from 'components/ContainerLoader/ContainerLoader';

const finalAudio = `${process.env.REACT_APP_GLOBAL_MEDIA_URL}/media/git/voice/finish_node.mp3`;

export function NodeJupyter(props) {

    const { resource } = useParams();
    const { node_id } = useParams();
    const { lab_id } = useParams();
    const context = useContext(AuthContext);
    const { data, loading } = useAPI(`/api/labs/${lab_id}/nodes/${node_id}/${resource}`, 'GET');
    const [nodeInfo, setNodeInfo] = useState();
    const [nodeFinished, setNodeFinished] = useState(false);
    const [currentStep, setCurrentStep] = useState(0);
    const [userInput, setUserInput] = useState([''])
    const [steps, setSteps] = useState();
    const currentRef = useRef(null);
    const [drawerOpen, setDrawerOpen] = useState(false);
    const [isMuted, setIsMuted] = useState(true);
    const [showFinishConfirm, setShowFinishConfirm] = useState(false);
    const [startLab, setStartLab] = useState(true);
    const [codeSubmit, setCodeSubmit] = useState(false)
    const [userPublicIp, setUserPublicIp] = useState();
    const [loadingContainerStart, setLoadingContainerStart] = useState(false);
    const [progress, setProgress] = useState(0);
    const sessionId = localStorage.getItem('sessionId');
    const [copied, setCopied] = useState(false);
    const [showReloadConfirm, setShowReloadConfirm] = useState(false);
    const roundedPercentage = nodeFinished ? 100 : Math.ceil(currentStep / nodeInfo?.numOfSteps * 100);
    const parser = new Python3Parser();;
    const [showReveal, setShowReveal] = useState(false);

    const isCopyEnabled = copyEnabledChecker(context?.user)
    const activityTimerRef = useRef(null);
    const [maxUnlocked, setMaxUnlocked] = useState(0);
    const audioRef = useRef(null);
    const finalAudioRef = useRef(null);
    const viewContext = useContext(ViewContext)


    useEffect(() => {
        setMaxUnlocked(prev => Math.max(prev, currentStep));
    }, [currentStep]);

    const startActivityTimer = () => {
        activityTimerRef.current = setTimeout(handleInactivity, 900000);
    };

    const resetActivityTimer = () => {
        clearTimeout(activityTimerRef.current);
        startActivityTimer();
    };

    function handleInactivity() {
        setShowReloadConfirm(true);
        handleContainerDelete();
    }

    const handleContainerDelete = () => {
        const sessId = localStorage.getItem('sessionId');
        const options = {
            method: 'DELETE',
            url: `/api/container-instances`,
            data: { "sessionId": sessId },

            headers: {
                accept: 'application/json',
            }
        };

        axios
            .request(options)
            .then(async function (response) {
                localStorage.removeItem('sessionId');
            })
            .catch((err) => {
                console.log(err)
            });

    };

    const handleRefresh = () => {
        window.location.reload();
    };

    const handleGoBack = () => {
        navigate(-1);
    };

    useEffect(() => {
        if (data) {

            const jsonData = decoder(data);
            jsonData.numOfSteps = jsonData.steps.steps.length;
            setNodeInfo(jsonData);
            setSteps(jsonData.steps.steps);

        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data]);

    useEffect(() => {
        if (loadingContainerStart) {
            const interval = setInterval(() => {
                setProgress((prevProgress) => (prevProgress >= 95 ? 100 : prevProgress + 1));
            }, 1000);

            if (!loadingContainerStart) {
                clearInterval(interval);
            }
            return () => {
                clearInterval(interval);
            };
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [loadingContainerStart]);

    useEffect(() => {
        if (!steps) return;

        if (audioRef.current) {
            audioRef.current.pause();
        }

        const audioLink = `${process.env.REACT_APP_GLOBAL_MEDIA_URL}${steps[currentStep]?.voice}`;
        if (audioLink && !isMuted) {
            const newAudio = new Audio(audioLink);
            audioRef.current = newAudio;
            newAudio.play();
        }

        return () => {
            if (audioRef.current) {
                audioRef.current.pause();
            }
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentStep, isMuted]);

    useEffect(() => {
        if (!nodeFinished) return;

        if (audioRef.current) {
            audioRef.current.pause();
        }

        const audio = new Audio(finalAudio);
        finalAudioRef.current = audio;
        audio.play();

        viewContext.notification.show(
            props.t('Labs.Nodes.NodeAutomation.end'),
            'info',
            false
        );

        return () => {
            if (finalAudioRef.current) {
                finalAudioRef.current.pause();
            }
        };

    }, [nodeFinished])

    const handleCellValueChange = (index, field, value) => {

        setUserInput(prev =>
            prev.map((item, ind) => (
                ind === index ? { ...item, [field]: value } : item
            ))
        );

    };

    function handleIncorrectAttempt() {
        toast.dark(props.t('Labs.Nodes.NodeJupyter.toast.incorrect.code.warn'), {
            type: 'error',
            position: 'top-right',
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
        });
    }

    const handleVoiceClick = () => {
        resetActivityTimer()
        setIsMuted(!isMuted);
    };

    const moveToNext = () => {
        if (currentStep === nodeInfo.numOfSteps - 1) {

            setNodeFinished(true);
            return;
        }
        setCurrentStep(currentStep + 1);
    }

    const handleCopyButton = async () => {
        try {
            await navigator.clipboard.writeText(steps[currentStep]?.command);
            setCopied(true);
            setTimeout(() => {
                setCopied(false);
            }, 2000);
            toast.dark(props.t('Labs.Nodes.NodeAutomation.toast.warn'), {
                type: 'warning',
                position: 'top-right',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
        } catch (error) {
            toast.dark(props.t('Labs.Nodes.NodeAutomation.copyCode.alert'), {
                type: 'error',
                position: 'top-right',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
        }
    }

    const handleCopy = async (e) => {
        setCopied(true);
        setTimeout(() => {
            setCopied(false);
        }, 2000);
        toast.dark(props.t('Labs.Nodes.NodeAutomation.toast.warn'), {
            type: 'warning',
            position: 'top-right',
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
        });
    };

    const handleCopyDisabled = (e) => {
        e.preventDefault();
    }

    const inputCompare = (input) => {
        // \r\n is package specific as the parser expects it at each line break
        const userCodeTokens = parser.getAllTokens(input + '\r\n');
        // Filtering out only the tokens by removing spaces and the \r\n after parsing
        const userTokensArray = userCodeTokens
            .map((obj) => obj['text'])
            .filter((text) => text.trim() !== '' && text !== '\r\n');

        let expectedTokens;
        function processTokens(input) {
            return parser.getAllTokens(input + '\r\n');
        }
        expectedTokens = processTokens(steps[currentStep].exp_input);
        const expectedTokensArray = expectedTokens
            .map((obj) => obj['text'])
            .filter((text) => text.trim() !== '' && text !== '\r\n');

        // REGEX VALIDATION
        if (steps[currentStep].validation_type === "regex") {
            try {
                const pattern = new RegExp(steps[currentStep].exp_input, "s");
                return pattern.test(input);
            } catch (err) {
                console.error("Invalid regex in exp_input:", err);
                return false;
            }
        }
        //Comparing user code tokens against expected code tokens
        return _.isEqual(expectedTokensArray, userTokensArray);
    };

    const showConfirm = () => {
        setShowFinishConfirm(true);
    }

    const startLabClick = async () => {
        startActivityTimer();
        setLoadingContainerStart(!loadingContainerStart);
        const formData = {
            resource: nodeInfo.resource,
        };
        const options = {
            method: 'POST',
            url: `/api/user/labs/${lab_id}/nodes/${node_id}/start`,
            headers: {
                accept: 'application/json',
            },
            data: formData,
        };
        await axios
            .request(options)
            .then((response) => {
                new Promise((resolve) => setTimeout(resolve, 100));
                setLoadingContainerStart(false);
                setStartLab(false);
                localStorage.setItem('sessionId', response.data.session_id);
                setUserPublicIp(decoder(response.data.user_ip));
                if (context?.user?.stop_walkthrough?.includes(nodeInfo?.resource?.lab_resource_id) || nodeInfo.is_assessment === 1) {
                    setIsMuted(!isMuted)
                }
            })
            .catch((err) => {
                if (err.response.status === 403) {
                    navigate('/nopermission');
                } else {
                    navigate('/oops');
                }
            });
    };

    const handleRun = async () => {
        resetActivityTimer();
        let compiledOut;

        compiledOut = await inputCompare(userInput[userInput.length - 1]?.command);
        if (!compiledOut) {
            setCodeSubmit(false)
            return handleIncorrectAttempt()
        };
        setCodeSubmit(false)
        moveToNext()
        setUserInput([...userInput, ""])
    };

    const navigate = useNavigate();
    const navigateBack = () => {
        navigate(-1);
    };

    const handleFinish = () => {
        const formData = {
            sessionId: sessionId,
        };
        const options = {
            method: 'POST',
            url: `/api/user/labs/${lab_id}/nodes/${node_id}/end`,
            headers: {
                accept: 'application/json',
            },
            data: {
                ...formData,
                ...(nodeInfo.is_assessment === 1 && { completionPercent: roundedPercentage }),
            },
        };
        axios
            .request(options)
            .then(async function (response) {
                await new Promise((resolve) => setTimeout(resolve, 50)); // Adding a wait for api post to happen    
                if (nodeInfo?.is_assessment === 1) {
                    navigate(`/labs/${lab_id}/nodes`);
                } else {
                    navigate(`/labs/${lab_id}/nodes/${node_id}/quiz/attempt`);
                }
                localStorage.removeItem('sessionId');
            })
            .catch((err) => {
                navigate('/oops');
            });



    };

    const handleConfirmClick = () => {
        handleFinish();
    }

    const sendHeartbeat = () => {
        const formData = {
            node_id: node_id,
        };
        const options = {
            method: 'POST',
            url: `/api/container-instances/heartbeat`,
            headers: {
                accept: 'application/json',
            },
            data: formData,
        };

        axios
            .request(options)
            .then(function (response) {
            })
            .catch((err) => {
                console.log(err.response.status);
            });
    };

    useEffect(() => {
        //send heartbeat call every 4 mins
        const heartBeatId = setInterval(sendHeartbeat, 240000);

        return () => {
            clearInterval(heartBeatId);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleDrawer = () => {
        resetActivityTimer();
        setDrawerOpen(!drawerOpen);
    };

    const resetWalkthrough = (data) => {
        if ((data.status === 'finished') | (data.action === 'skip') | (data.action === 'tour:end')) {
            setIsMuted(!isMuted);
        }
    };

    const isSupervisor = useCan('node.progress.flag');
    const isAssessmentNode = nodeInfo?.is_assessment;;
    const canReveal = !!(isSupervisor && isAssessmentNode);

    return (
        <>
            {/* container loading animation */}
            <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={loadingContainerStart}>
                {!startLab && nodeInfo.is_assessment !== 1 ? (
                    <Joyride
                        open={nodeInfo?.resource?.walkthrough?.open}
                        run={nodeInfo?.resource?.walkthrough?.run}
                        steps={nodeInfo?.resource?.walkthrough?.steps || []}
                        resourceId={nodeInfo?.resource?.lab_resource_id}
                        disableOverlay={true}
                        callback={resetWalkthrough}
                    />
                ) : null}
                <ContainerLoader 
                    progress={progress} 
                    loadingContainerStart={loadingContainerStart} 
                    containerHints={nodeInfo?.container_loader_json} 
                />
            </Backdrop>
            {!nodeInfo?.steps || nodeInfo?.steps?.length === 0 || loading ?
                <>
                    <LoadingBackdrop isOpen={true} />
                </> :
                <> <ToastContainer
                    data-testid="nodeJupyter-warning-toast"
                    id="warning-toast"
                    position="top-right"
                    autoClose={10000}
                    hideProgressBar={false}
                    newestOnTop
                    closeOnClick
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                    limit={4}
                />
                    <InfoDrawer
                        handleDrawer={handleDrawer}
                        drawerOpen={drawerOpen}
                        titleText={props.t('Labs.Nodes.NodeJupyter.reference', { LabName: nodeInfo.labName })}
                        displayData={nodeInfo?.content?.reference_data}
                    />
                    <ConfirmationCard
                        title={props.t("Labs.Nodes.NodeJupyter.confirm.timeout.title")}
                        body={props.t("Labs.Nodes.NodeJupyter.confirm.timeout.body")}
                        showCard={showReloadConfirm}
                        setShowCard={setShowReloadConfirm}
                        handleCancel={handleGoBack} // Pass the refresh handler
                        handleConfirm={handleRefresh} // Pass the go back handler
                        confirmButtonText={props.t('Labs.Nodes.NodeJupyter.confirm.button.refresh')}
                        cancelButtonText={props.t('Labs.Nodes.NodeJupyter.confirm.button.goBack')}
                    />
                    <ConfirmationCard
                        title={nodeInfo?.is_assessment ? props.t('Labs.Nodes.NodeJupyter.confirm.start.assessment.title') : props.t('Labs.Nodes.NodeJupyter.confirm.start.default.title')}
                        body={props.t('Labs.Nodes.NodeJupyter.confirm.start.default.body')}
                        showCard={startLab}
                        setShowCard={setStartLab}
                        handleCancel={navigateBack}
                        handleConfirm={startLabClick}
                    />
                    <BackConfirmationCard
                        isSaveAvailable={false}
                        isContainerLab={true}
                        sessionId={sessionId}
                    />
                    <div data-testid="nodeJupyter-titleContainer" className={ImportedStyles.titleContainer}>
                        <div style={{ display: 'flex' }}>
                            <Avatar
                                sx={{
                                    bgcolor: pink[500],
                                    alignSelf: 'center',
                                    mr: 1,
                                    width: 55,
                                    height: 55,
                                }}
                            >
                                <SmartToyIcon sx={{ width: 42, height: 42 }} />
                            </Avatar>
                            <Typography
                                variant="h3"
                                sx={{
                                    textTransform: 'uppercase',
                                    color: '#76EAD7',
                                }}
                            >
                                {nodeInfo?.name}
                            </Typography>
                        </div>
                        <div data-testid="nodeJupyter-titleContainer-finishButtonContainer" id="finishButtonContainer" className={Styles.finishButtonContainer}>
                            <span style={{ display: 'flex', flexDirection: 'row' }}>
                                <LightTooltip
                                    title={nodeInfo?.is_assessment
                                        ? ((roundedPercentage > 70) ? props.t('Labs.Nodes.NodeJupyter.tooltip.finish.done') : props.t('Labs.Nodes.NodeJupyter.tooltip.finish.assessment'))
                                        : (nodeFinished ? props.t('Labs.Nodes.NodeJupyter.tooltip.finish.done') : props.t('Labs.Nodes.NodeJupyter.tooltip.finish.info'))
                                    }
                                    arrow
                                    placement="left"
                                    classes={{
                                        tooltip: {
                                            backgroundColor: '#fff',
                                            color: 'rgba(0, 0, 0, 0.87)',
                                            boxShadow: '0 2px 5px rgba(0, 0, 0, 0.15)',
                                            fontSize: 11,
                                        },
                                    }}
                                >
                                    <span>

                                        <button
                                            data-testid="nodeJupyter-titleContainer-finishButtonContainer-finishButton"
                                            variant="extended"
                                            className={Styles.finishButton}
                                            onClick={() => {
                                                nodeInfo?.is_assessment ? showConfirm() : handleFinish()
                                            }}
                                            disabled={
                                                !nodeInfo?.is_assessment
                                                    ? !nodeFinished
                                                    : roundedPercentage < 70
                                            }
                                        >
                                            <KeyboardDoubleArrowRightIcon />
                                            {props.t('Labs.Nodes.NodeJupyter.button.finish')}
                                        </button>
                                    </span>

                                </LightTooltip>
                                <ConfirmationCard
                                    title={(roundedPercentage > 70 && roundedPercentage < 100) ? props.t('Labs.Nodes.NodeJupyter.confirm.completed.title.warn') : props.t('Labs.Nodes.NodeJupyter.confirm.completed.title.default')}
                                    body={(roundedPercentage > 70 && roundedPercentage < 100) ? props.t('Labs.Nodes.NodeJupyter.confirm.completed.body.warn') : props.t('Labs.Nodes.NodeJupyter.confirm.completed.title.default')}
                                    showCard={showFinishConfirm}
                                    setShowCard={setShowFinishConfirm}
                                    handleConfirm={handleConfirmClick}
                                />
                            </span>

                            {canReveal && (
                                <div
                                    data-testid="nodeJupyter-titleContainer-revealAnswer"
                                    id="revealAnswer"
                                    className={Styles.fabContainer}
                                    onClick={() => setShowReveal(true)}
                                    style={{ order: 1, marginRight: 8 }}
                                >
                                    <LightTooltip
                                        title={props.t('Labs.Nodes.NodeJupyter.tooltip.revealAnswer')}
                                        arrow
                                        placement="left"
                                        classes={{
                                            tooltip: {
                                                backgroundColor: '#fff',
                                                color: 'rgba(0, 0, 0, 0.87)',
                                                boxShadow: '0 2px 5px rgba(0, 0, 0, 0.15)',
                                                fontSize: 11,
                                            },
                                        }}
                                    >
                                        <Fab color="primary" size="medium">
                                            <VisibilityIcon />
                                        </Fab>
                                    </LightTooltip>
                                </div>
                            )}

                            <div data-testid="nodeJupyter-titleContainer-infoDrawer" id="infoDrawer" className={Styles.fabContainer} onClick={handleDrawer} style={{ order: 2 }}>
                                <LightTooltip
                                    title={props.t("Labs.Nodes.NodeJupyter.tooltip.reference")}
                                    arrow
                                    placement="left"
                                    classes={{
                                        tooltip: {
                                            backgroundColor: '#fff',
                                            color: 'rgba(0, 0, 0, 0.87)',
                                            boxShadow: '0 2px 5px rgba(0, 0, 0, 0.15)',
                                            fontSize: 11,
                                        },
                                    }}
                                >
                                    <Fab color="primary" size="medium">
                                        <LightbulbIcon />
                                    </Fab>
                                </LightTooltip>
                            </div>
                        </div>
                    </div>

                    <div data-testid="nodeJupyter-jupyterContainer" id="jupyterContainer" className={Styles.jupyterContainer} >
                        <div data-testid="nodeJupyter-jupyterContainer-cellContainer" id="cellContainer" className={Styles.cellContainer}>
                            <div data-testid="nodeJupyter-jupyterContainer-cellContainer-codeEditor" id="codeEditor" style={{ overflowY: 'auto', maxHeight: '92vh', paddingBottom: "1em" }} >
                                {userInput.map((ter, ind) => (
                                    <JupyterTerminal key={ind}
                                        setCodeSubmit={setCodeSubmit}
                                        terminalLength={userInput?.length}
                                        terminal={ter}
                                        ind={ind}
                                        userInput={userInput}
                                        userPublicIp={userPublicIp}
                                        savedSteps={userInput.length - 1 !== ind}
                                        handleCellValueChange={handleCellValueChange}
                                        resetActivityTimer={resetActivityTimer} />
                                ))}
                            </div>
                            <div data-testid="nodeJupyter-jupyterContainer-cellContainer-buttonContainer" className={Styles.buttonContainer} style={{ backgroundColor: "#292d3e", borderRadius: "8px" }}>
                                <LightTooltip
                                    title={props.t('Labs.Nodes.NodeJupyter.tooltip.submit')}
                                    arrow

                                    onClick={handleRun}

                                    classes={{
                                        tooltip: {
                                            backgroundColor: '#fff',
                                            color: 'rgba(0, 0, 0, 0.87)',
                                            boxShadow: '0 2px 5px rgba(0, 0, 0, 0.15)',
                                            fontSize: 11,
                                        },
                                    }}
                                >
                                    <span>
                                        <button data-testid="nodeJupyter-jupyterContainer-cellContainer-submitButton" id="submitButton" className={Styles.buttonStyles} disabled={!codeSubmit}>{props.t('Labs.Nodes.NodeJupyter.button.submit')}  </button>
                                    </span>
                                </LightTooltip>
                            </div>
                        </div>
                        <div data-testid="nodeJupyter-jupyterContainer-infoContainer" className={Styles.infoContainer}  >
                            <InstructionPane
                                props={props}
                                steps={steps}
                                currentStep={currentStep}
                                isMuted={isMuted}
                                copied={copied}
                                setIsMuted={setIsMuted}
                                isCopyEnabled={isCopyEnabled}
                                onHandleCopy={handleCopy}
                                onHandleVoiceClick={handleVoiceClick}
                                onHandleCopyDisabled={handleCopyDisabled}
                                onHandleCopyButton={handleCopyButton}
                                nodeInfo={nodeInfo}
                                theme='light'
                            />
                        </div>
                        <div>
                            <span data-testid="nodeJupyter-jupyterContainer-infoContainer-codeEditorTimeLine" id="codeEditorTimeLine" className={Styles.codeEditorTimeLine}>
                                <NodeTimeline
                                    nodeFinished={nodeFinished}
                                    currentStep={currentStep}
                                    steps={steps}
                                    currentRef={currentRef}
                                    hideToolTip={true}
                                    collapsable={true}
                                    setCurrentStep={setCurrentStep}
                                    maxUnlocked={maxUnlocked}
                                />
                            </span>
                        </div>
                    </div>
                    {(!startLab && !nodeFinished && nodeInfo.is_assessment !== 1 && nodeInfo?.resource?.config?.chatbotTopic) && (
                        <HelperChat
                            active={props.aiChat}
                            topic={nodeInfo?.resource?.config?.chatbotTopic}
                        />
                    )}
                    {nodeFinished && <Feedback isInNode={true} nodeName={nodeInfo.name} labName={nodeInfo.labName} />}

                    <RevealAnswerKey
                        showAnswerKeyDialog={showReveal}
                        setShowAnswerKeyDialog={setShowReveal}
                        steps={steps}
                        currentStep={currentStep}
                        language={nodeInfo?.resource?.config?.language}
                        nodeId={node_id}
                        nodeName={nodeInfo?.name}
                        labTitle={nodeInfo?.labName}
                    />
                </>
            }
        </>
    )
}
